import { FC } from 'react'

import { Memo } from '@/hoc/Memo'

export interface IconSchema {
  name?: string
  fill?: string
  stroke?: string
  className?: string
  width?: number
  height?: number
  onClick?: () => void
}

export const Icon: FC<IconSchema> = Memo(
  ({ name, onClick, ...props }: IconSchema) => {
    console.log(name)

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const LocIcon = require(`!svg-react-loader!../../assets/icons/${name}.svg`)
    return <LocIcon onClick={onClick} {...props} />
  },
)
